import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import Ranking from "@/pages/home/components/Ranking";
import Feed from "@/pages/home/components/Feed";
import DeepDive from "@/pages/home/components/DeepDive";
import Trace from "@/pages/home/components/Trace";
import Community from "@/pages/home/components/Community";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Feed />
        <DeepDive />
        <Trace />
        <Community />
      </main>
      <Footer />

      {/* back-to-top */}
      <a
        href="#top"
        aria-label="返回顶部"
        className="fixed bottom-6 right-6 z-40 grid h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-none transition-opacity hover:opacity-85"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </a>
    </div>
  );
}